<template>
  <v-app :dark="darkTheme">
    <nav-bar></nav-bar>

    <v-main>
      <notifications></notifications>
      <v-container fluid :style="`height: 100%;background-image: url(${require('@/assets/background.jpg')}); background-repeat: no-repeat;
  background-position: center top;`" class="pa-0">
        <v-layout fill-height>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-main>

    <footer-bar v-if="!isAuthenticated"></footer-bar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import NavBar from '@/components/NavBar'
import Notifications from '@/components/Notifications'
import FooterBar from '@/components/FooterBar'

export default {
  name: 'App',
  components: {
    NavBar,
    Notifications,
    FooterBar
  },
  created () {
    var locale = this.fetchLocale()

    if (this.$i18n.locale !== locale) {
      this.$vuetify.lang.current = locale
      this.$i18n.locale = locale
    }

    document.title = this.$t('title')
  },
  computed: {
    ...mapGetters(['darkTheme']),
    ...mapGetters('auth', ['isAuthenticated'])
  }
}
</script>
